import script from "./RoleRequiredWeekly.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleRequiredWeekly.vue?vue&type=script&setup=true&lang=ts"

import "./RoleRequiredWeekly.vue?vue&type=style&index=0&id=6fd0330d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fd0330d"]])

export default __exports__